<template>
    <div class="d-none d-md-block">
        <button v-on:click="move(  BlockId, 'down' )" class="btn bg-info float-right mr-0"><i  class="fas fa-arrow-down"></i></button>
    </div>
</template>

<script>
	export default {
		props: [
		'LoopIndex', 'BlockId', 'MenuItemId'
		],

		methods: {
            move(BlockId, direction) {
                let formData = new FormData();
                formData.append('BlockId', BlockId);

                axios.post( '/manage/block/move/'+direction+'/'+BlockId + '/' + this.MenuItemId, formData )
                    .then(function(data) {
                        console.log(data);
                        window.location.reload(true);
                    }.bind(this)).catch(function(data) {
                    console.log('error', data);
                    alert('f');
                });
            }
        }
	}
</script>


// WEBPACK FOOTER //
// resources/js/components/MoveBlockButtons.vue